export type ThemeMode = 'light' | 'dark';

export const readStoredTheme = (): ThemeMode => {
    try {
        const s = localStorage.getItem('travelDiarySettings');
        if (!s) return 'light';
        const p = JSON.parse(s);
        return p.theme === 'dark' ? 'dark' : 'light';
    } catch {
        return 'light';
    }
};

export const applyThemeToDocument = (theme: ThemeMode) => {
    if (theme === 'dark') document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
};

export const persistTheme = (theme: ThemeMode) => {
    try {
        const raw = JSON.parse(localStorage.getItem('travelDiarySettings') || '{}');
        localStorage.setItem('travelDiarySettings', JSON.stringify({ ...raw, theme }));
    } catch { /* ignore */ }
};
